<template>
  <security-page>
    <template #left>
      <page-illustration :src="illustration" />
    </template>
    <template #right>
      <forgot-password-form />
    </template>
  </security-page>
</template>

<script>
import SecurityPage from '@/views/foravila/security/components/SecurityPage.vue'
import PageIllustration from '@/views/foravila/security/components/PageIllustration.vue'
import ForgotPasswordForm from '@/views/foravila/security/components/ForgotPasswordForm.vue'

export default {
  components: {
    SecurityPage,
    PageIllustration,
    ForgotPasswordForm,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      illustration: require('@/assets/foravila/images/illustrations/forgot-password.svg'),
    }
  },
}
</script>
